import { render, staticRenderFns } from "./EligibilitySimple.vue?vue&type=template&id=5f2a4088&"
import script from "./EligibilitySimple.vue?vue&type=script&lang=js&"
export * from "./EligibilitySimple.vue?vue&type=script&lang=js&"
import style0 from "./EligibilitySimple.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports